'use client'

import styled from 'styled-components'

import {
  Button,
  ResponsiveImage,
  TypeStyleBodyDefault,
  fromLg,
  fromXl,
} from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../_providers/TranslationProvider.client'
import { NextLink } from '../../../navigation/NextLink'
import { useBreadcrumbData } from '../shared/Breadcrumbs/PageBreadcrumbs'

import * as Styles from './PdpRegionLocked'

export const PdpRegionLocked = ({
  genderCategory,
  categoryId,
}: {
  genderCategory: string | undefined
  categoryId: string | undefined
}) => {
  const {
    pages: { regionLocked: t },
  } = useTranslation()

  const { links } = useBreadcrumbData({ genderCategory, categoryId })

  return (
    <Styles.FlexContainer>
      <Styles.Img
        src='https://cdn.shopify.com/s/files/1/0298/0967/2276/files/RegionLock_Hero_BG.jpg?v=1769103403'
        alt={t.ariaLabel}
        loading='lazy'
        aspectRatios={{ sm: 1, md: 1 }}
        widths={{ unit: 'vw', sm: 100, md: 100 }}
      />

      <Styles.Content>
        <Styles.Title>{t.title}</Styles.Title>
        <TypeStyleBodyDefault>{t.description}</TypeStyleBodyDefault>
        <Styles.ButtonGroup>
          <Button size='large' variant='black-on-white' as={NextLink} href={links.category || '/'}>
            {t.continueShoppingBtn}
          </Button>
          <Button size='large' as={NextLink} href='/'>
            {t.returnHomeBtn}
          </Button>
        </Styles.ButtonGroup>
      </Styles.Content>
    </Styles.FlexContainer>
  )
}

export const FlexContainer = styled.div`
  display: grid;
  grid-template-rows: auto;
  place-items: center;

  ${fromLg} {
    grid-template-columns: 1fr 1fr;
  }
`

export const Img = styled(ResponsiveImage)`
  max-height: 390px;
  object-position: top;

  ${fromLg} {
    max-height: 600px;
  }

  ${fromXl} {
    max-height: 900px;
  }
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;

  ${fromLg} {
    font-size: 28px;
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(5)};
  justify-content: center;

  ${fromLg} {
    flex-direction: row;
  }
`

export const Content = styled.div`
  padding: ${o => o.theme.spacing(10, 4)};
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(5)};
  text-align: center;
  max-width: 360px;

  ${fromLg} {
    max-width: 640px;
    padding: ${o => o.theme.spacing(10)};
  }
`
